import { HTMLAttributes } from 'react'
import { clsx } from 'shared/utils'
import { LoaderSize } from 'shared/types'
import { Container, useStyles } from './Loader.style'

export interface LoaderProps extends HTMLAttributes<HTMLDivElement> {
  size?: LoaderSize
}

const Loader = ({ size = 'medium', ...props }: LoaderProps) => {
  const classes = useStyles({ size })
  return (
    <Container {...props}>
      <div className={clsx(classes.spinner, classes[size])} />
    </Container>
  )
}

export default Loader
